import ActivityLogIcon from './component'

export default ActivityLogIcon
